export type ContentBlock = {
  id: number;
  key: string;
  title?: string | null;
  body?: string | null;
  imageUrl?: string | null;
  linkUrl?: string | null;
  sortOrder: number;
  active: boolean;
};

class ContentService {
  private apiUrlHost = `https://api.kofc1056.org/api`;

  public async getByKey(key: string): Promise<ContentBlock[]> {
    try {
      const res = await fetch(`${this.apiUrlHost}/content/${encodeURIComponent(key)}`);
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    } catch (ex) {
      console.error("Exception retrieving content", ex);
      return [];
    }
  }
}

export default ContentService;